import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  useTheme,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";
import { trackLead } from "../../../utils/fbConversion";


const inputStyle = {
  background: "#ffffff",
  borderRadius: "12px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    "& fieldset": {
      borderColor: "#e4e4e7",
    },
    "&:hover fieldset": {
      borderColor: "#b9b9c3",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#5e17eb",
    },
  },
};

const DropAQueryv2 = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // --- Zoho Form State & Logic ---
  const [gclid, setGclid] = useState('');
  const [formError, setFormError] = useState('');
  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    website: window.location.href.slice(0, 250),
    description: window.location.href.includes("full-stack-web-development")
      ? "Full Stack Web Development"
      : window.location.href.includes("devops-and-cloud-training-online")
      ? "DevOps and Cloud with GenAI Master Program"
      : "DevOps and Cloud with GenAI Job Ready Program",
  });
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });

  useEffect(() => {
    const urlGclid = new URLSearchParams(window.location.search).get("gclid");
    if (urlGclid) {
      localStorage.setItem('gclid', urlGclid);
      setGclid(urlGclid);
    } else {
      const storedGclid = localStorage.getItem('gclid');
      setGclid(storedGclid);
    }
  }, []);

  const validateFirstName = (value) => (!value ? 'First name is required' : '');
  const validateLastName = (value) => (!value ? 'Last name is required' : '');
  const validateEmail = (value) => {
    if (!value) return 'Email is required';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) ? '' : 'Invalid email address';
  };
  const validatePhone = (value) => {
    if (!value) return 'Phone number is required';
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(value) ? '' : 'Phone number must be 10 digits';
  };

  const handleChange = (e, field) => {
    const { value } = e.target;
    setFormValues({ ...formValues, [field]: value });

    let error = '';
    switch (field) {
      case 'firstName': error = validateFirstName(value); break;
      case 'lastName': error = validateLastName(value); break;
      case 'email': error = validateEmail(value); break;
      case 'phone': error = validatePhone(value); break;
      default: break;
    }
    setErrors({ ...errors, [field]: error });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const firstNameError = validateFirstName(formValues.firstName);
    const lastNameError = validateLastName(formValues.lastName);
    const emailError = validateEmail(formValues.email);
    const phoneError = validatePhone(formValues.phone);

    if (firstNameError || lastNameError || emailError || phoneError) {
      setErrors({ firstName: firstNameError, lastName: lastNameError, email: emailError, phone: phoneError });
      setFormError(firstNameError || lastNameError || emailError || phoneError);
      return;
    }

    trackLead({
      contentName: "Drop a Query",
      email: formValues.email,
      phone: formValues.phone,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
    });

    document.forms['WebToLeads774394000000902049'].submit();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: "18px", overflow: "hidden" } }}
    >
      <IconButton
        aria-label="Close Eligibility Form"
        onClick={onClose}
        sx={{ position: "absolute", right: 14, top: 14, zIndex: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          {!isMobile && (
            <Box flex={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center", background: "#ffffff" }}>
              <img loading="lazy" src={"https://img.freepik.com/free-photo/cloud-shaped-heads-collage_23-2149879910.jpg?t=st=1730546028~exp=1730549628~hmac=d720c9d6adca714772288b50d08cf250f685d9d821ec21cc954bf00626499062&w=740"} alt="Consultation Offer" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </Box>
          )}

          <Box flex={1} sx={{ p: { xs: 3, md: 4 } }}>
            <motion.div initial={{ opacity: 0, y: 25 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}>
              <Typography variant="h5" fontWeight={700} mb={1} sx={{ fontFamily: "Poppins, sans-serif" }}>
                Drop a Query
              </Typography>
              <Typography color="text.secondary" mb={3} sx={{ fontFamily: "Poppins, sans-serif" }}>
                Talk to Our Expert Consultant
              </Typography>

              {/* --- Zoho Form --- */}
              <form id="webform774394000000902049" action="https://crm.zoho.in/crm/WebToLeadForm" name="WebToLeads774394000000902049" method="POST" onSubmit={handleFormSubmit} acceptCharset="UTF-8">
                <input type="hidden" name="xnQsjsdp" defaultValue="7d15d6ae01d5e4e362e4c5030d41265b910e3619da9c7a66ed4112cfbcdc414b" />
                <input type="hidden" name="xmIwtLD" defaultValue="44e1da7b6f7318fd661008fffb32f7aee45ebf52e977f8bcabba7a19c3c67dd9d51c23bfa87adc62bc6ea1224971de37" />
                <input type="hidden" name="actionType" defaultValue="TGVhZHM=" />
                <input type="hidden" name="returnURL" defaultValue="https://paperlive.in/thankyou" />
                <input type='hidden' id="zc_gad" name="zc_gad" value={gclid} />
                <input type="hidden" id="Website" name="Website" value={formValues.website} />
                <input type="hidden" id="Description" name="Description" value={formValues.description} />
                
                <Box sx={{ display: "grid", gap: "14px" }}>
                  <TextField
                    value={formValues.firstName}
                    onChange={(e) => handleChange(e, "firstName")}
                    label="First Name"
                    id="First_Name"
                    name="First Name"
                    fullWidth
                    variant="outlined"
                    sx={inputStyle}
                    InputProps={{ startAdornment: <InputAdornment position="start"><AssignmentIndIcon /></InputAdornment> }}
                    error={!!errors.firstName}
                  />
                  <TextField
                    value={formValues.lastName}
                    onChange={(e) => handleChange(e, "lastName")}
                    label="Last Name"
                    id="Last_Name"
                    name="Last Name"
                    fullWidth
                    variant="outlined"
                    sx={inputStyle}
                    InputProps={{ startAdornment: <InputAdornment position="start"><AssignmentIndIcon /></InputAdornment> }}
                    error={!!errors.lastName}
                  />
                  <TextField
                    value={formValues.email}
                    onChange={(e) => handleChange(e, "email")}
                    label="Email"
                    id="Email"
                    name="Email"
                    type="email"
                    fullWidth
                    variant="outlined"
                    sx={inputStyle}
                    InputProps={{ startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment> }}
                    error={!!errors.email}
                  />
                  <TextField
                    value={formValues.phone}
                    onChange={(e) => handleChange(e, "phone")}
                    label="Phone Number"
                    id="Phone"
                    name="Phone"
                    type="tel"
                    fullWidth
                    variant="outlined"
                    sx={inputStyle}
                    InputProps={{ startAdornment: <InputAdornment position="start"><PhoneIphoneIcon /></InputAdornment> }}
                    error={!!errors.phone}
                  />
                    <Typography color="red">{formError}</Typography>
                  <Button
                    aria-label="Submit Drop a Query Form"
                    variant="contained"
                    fullWidth
                    sx={{
                      fomtFamily: "Poppins, sans-serif",
                      mt: 1,
                      borderRadius: "12px",
                      fontWeight: 700,
                      height: 45,
                      textTransform: "none",
                      background: "#5e17eb",
                      ":hover": { background: "#4d13c6" },
                    }}
                    type="submit"
                  >
                    Submit
                  </Button>
                </Box>
              </form>
            </motion.div>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DropAQueryv2;
